// extracted by mini-css-extract-plugin
export default {"wrapper":"RowsPerPage_wrapper__rIbn+","reportPaginationWrapper":"RowsPerPage_reportPaginationWrapper__LIkVL"};